<div class="prompt">Please provide further details for the chat</div>
<form [formGroup]="form">
    <div class="form-control">
        <label for="member-id">Member ID</label>
        <input 
            formControlName="memberId" 
            id="member-id" 
            class="ods-text-input"  
            type="text"
            minlength="11"
            maxlength="11"  
            placeholder="Enter an 11 digit member ID"
            inputNumeric
        />
        @if (controlHasError('memberId')) {
            @if (form.get('memberId').getError('required')) {
                <small class="error">Member ID is required.</small>
            }
            @if (form.get('memberId').getError('minlength')) {
                <small class="error">Member ID must be 11 characters long.</small>
            }           
        }
    </div>
    <div class="form-control">
        <label for="dob">Member Date of Birth</label>
        <input 
            formControlName="dob" 
            id="dob" 
            class="ods-text-input" 
            [class.placeholder]="!form.get('dob').value"
            type="date"
            [max]="formattedMaxDate"
            [min]="formattedMinDate"
        />
        @if (controlHasError('dob')) {
            @if (form.get('dob').getError('required')) {
                <small class="error">Date of Birth is required.</small>
            }
            @if (form.get('dob').getError('maxDateExceeded')) {
                <small class="error">Date cannot be after today.</small>
            }
            @if (form.get('dob').getError('minDateExceeded')) {
                <small class="error">Date exceeds minimum allowed date.</small>
            }
        }
    </div>
    <div class="form-control">
        @if (isPharmacyTeam_()) {
            <label for="provider-npi">Provider NPI</label>
            <input 
                formControlName="providerNpi" 
                id="provider-npi" 
                class="ods-text-input"  
                type="text"
                minlength="10"
                maxlength="10"  
                placeholder="Enter a 10 digit provider NPI"
                inputNumeric
            />
            @if (controlHasError('providerNpi')) {
                @if (form.get('providerNpi').getError('required')) {
                    <small class="error">Provider NPI is required.</small>
                }
                @if (form.get('providerNpi').getError('minlength')) {
                    <small class="error">Provider NPI must be 10 characters long.</small>
                }           
            }
        } @else {
            <label for="security-settings">Security Settings</label>
            <ods-select 
                id="security-settings" 
                (change)="handleSecuritySettingsValueChange($event)"
                (blur)="markSecuritySetting()"
            >
                @for (setting of securitySettings(); track setting) {
                    <ods-select-option [value]="setting.key">
                        {{ setting.description }} - TIN {{ setting.key }}
                    </ods-select-option> 
                }
            </ods-select>
            @if (controlHasError('securitySetting')) {
                <small class="error">Security Setting is required.</small>
            }
        }
    </div>
    <ods-button 
      class="start-session-btn" 
      [disabled]="isButtonDisabled()"
      (click)="submit()"
    >
      Start Chat Session
    </ods-button>
</form>